import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StaticNavigation from './StaticNavigation';
import styles from './ContactUsStaticPage.css';
import CovetrusLogoFull from '../../assets/CovetrusLogoFull';

const ContactUsStaticPage = props => {
  const { pharmacyType } = props;
  let contactInfo = null;
  switch (pharmacyType) {
    default:
      contactInfo = (
        <div className={styles.contactInfo}>
          <CovetrusLogoFull />
          <br />
          <p className={styles.hours}>
            For help with your compounded medications, please call our
          </p>
          <p className={styles.hours}>pharmacy at</p>
          <br />
          <h2 className={styles.phone}>877-518-4589</h2>
          <br />
          <p className={styles.hours}>Support Hours: M-F 8AM-8PM</p>
          <h3 className={styles.url}>orders-compounding@covetrus.com</h3>
        </div>
      );
      break;
  }

  return (
    <div className={styles.container}>
      <StaticNavigation title="Contact Us!" />
      <h1 className={styles.title}>Customer Service</h1>
      <p className={styles.subTitle}>
        Contact your customer service team if you have questions about your
        order
      </p>
      <div className={styles.brandsCsWrapper}>{contactInfo}</div>
    </div>
  );
};

ContactUsStaticPage.propTypes = {
  pharmacyType: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const pharmacyType =
    state && state.userInfo && state.userInfo.customer
      ? state.userInfo.product.productCompoundAttributeSubsidiaryBrand
      : '';
  return { pharmacyType };
}

export default connect(mapStateToProps, null)(ContactUsStaticPage);



// WEBPACK FOOTER //
// ./src/components/StaticPages/ContactUsStaticPage.jsx